import Vue from 'vue'

import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css';
import '../css/date-picker.scss';

Vue.use(DatePick)
